import React, { useEffect, useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import './TestimonialSection.css';

const testimonials = [
  {
    text: 'Experiencing Kalyug Band live was amazing! Their talent and passion filled every moment, creating a magical atmosphere that mesmerized the audience throughout. Truly unforgettable, I would love to see them perform again and highly recommend their shows to anyone seeking a fantastic musical experience.',
    name: 'Bhavana',
    role: 'Pune',
  },
  {
    text: 'Thank you for making our event truly special. The decorations were beautiful, and Zarinova’s team worked seamlessly to create a stunning setup. Everyone loved it! Your prompt and helpful service made all the difference. I strongly recommend your decoration services to anyone planning an event.',
    name: 'Kayani',
    role: 'Pune',
  },
  {
    text: 'Zarinova Entertainments delivered an extraordinary music experience. The talent was impressive, and the event was organized perfectly. A night filled with soulful melodies that left everyone inspired and in awe. Highly recommend their live music performances for any occasion.',
    name: 'Nikhil',
    role: 'Pune',
  },
  {
    text: 'The birthday decorations were fantastic! The creativity and attention to detail made my day magical. The beautiful setup truly enhanced my celebration, and I am so happy with how everything turned out. A wonderful team and service I would recommend to anyone.',
    name: 'Aamir',
    role: 'Pune',
  },
  {
    text: 'I can’t thank Zarinova Entertainments enough for the adorable baby shower decorations. The warm ambiance created a perfect setting for our celebration. Their professionalism and thoughtful touches made the day unforgettable. I highly recommend their services to anyone seeking memorable event decor.',
    name: 'ONKAR GURAV',
    role: 'Pune',
  },
  {
    text: 'Thanks to Zarinova Entertainments, my event was a complete success. The team listened carefully and executed everything perfectly. I’m thrilled with how everything turned out and highly recommend them to anyone wanting an outstanding event experience.',
    name: 'Tejesh Ankushkar',
    role: 'Pune',
  },
  {
    text: 'Thanks to Zarinova Entertainments, my event was a complete success. The team listened carefully and executed everything perfectly. I’m thrilled with how everything turned out and highly recommend them to anyone wanting an outstanding event experience.',
    name: 'Dj Danny',
    role: 'Pune',
  },
  {
    text: 'Thanks to Zarinova Entertainments, my event was a complete success. The team listened carefully and executed everything perfectly. I’m thrilled with how everything turned out and highly recommend them to anyone wanting an outstanding event experience.',
    name: 'Shambhawi Singh',
    role: 'Pune',
  },
  {
    text: 'Thanks to Zarinova Entertainments, my event was a complete success. The team listened carefully and executed everything perfectly. I’m thrilled with how everything turned out and highly recommend them to anyone wanting an outstanding event experience.',
    name: 'Sadolkar Ajinkya',
    role: 'Pune',
  },
  {
    text: 'Thanks to Zarinova Entertainments, my event was a complete success. The team listened carefully and executed everything perfectly. I’m thrilled with how everything turned out and highly recommend them to anyone wanting an outstanding event experience.',
    name: 'Ankita',
    role: 'Pune',
  },
  {
    text: 'Thanks to Zarinova Entertainments, my event was a complete success. The team listened carefully and executed everything perfectly. I’m thrilled with how everything turned out and highly recommend them to anyone wanting an outstanding event experience.',
    name: 'Kajal',
    role: 'Pune',
  }
];

const TestimonialSection = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % testimonials.length);
    }, 4000);
    return () => clearInterval(interval);
  }, []);

  const handleNext = () => {
    setCurrentIndex((prev) => (prev + 1) % testimonials.length);
  };

  const handlePrev = () => {
    setCurrentIndex((prev) => (prev - 1 + testimonials.length) % testimonials.length);
  };

  const { text, name, role } = testimonials[currentIndex];

  return (
    <section className="testimonial-section d-flex justify-content-center align-items-center text-center">
      <div className="container">
        <div className="testimonial-box p-4 p-md-5">
          <div className="arrows d-flex justify-content-between mb-3">
            <button className="arrow-btn" onClick={handlePrev}>&larr;</button>
            <button className="arrow-btn" onClick={handleNext}>&rarr;</button>
          </div>
          <h4 className="testimonial-text fw-bold px-3">
            {text}
          </h4>
          <div className="testimonial-user mt-4">
            <h6 className="text-white m-0">{name}</h6>
            <small className="text-light">{role}</small>
          </div>
          <hr className="testimonial-divider my-4" />
          <p className="text-light small mb-0">
            Trusted by clients across industries.
          </p>
        </div>
      </div>
    </section>
  );
};

export default TestimonialSection;
